// Enumerations
import { AppErrorEnumeration } from 'enumerations/app-error.enumeration';
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
import { UploadIdStatesEnumeration } from 'containers/upload-id/enumerations/upload-id-states.enumeration';
import { UploadIdOcrStatesEnumeration } from '../enumerations/upload-id-ocr-states.enumeration';
// Types
import { WsResponseType } from 'types/ws-response.type';
import {
  UploadIdVerificationBuilderHandlersType,
  UploadIdVerificationManageListenVeridasIframeEventsHandlerType,
  UploadIdVerificationMethodsHandlersType,
  UploadIdVerificationReceiveDataBuilderHandlersType,
  UploadIdVerificationUpdateHeaderBackClickHandlerType,
} from './types/upload-id-verification.handlers.type';
import {
  customerInformationNeedApproval,
  eventIsNotFromVeridas,
  isQrProcessFinished,
  OCRDataIsSuccessfullyVerified,
  shouldShowErrorFromEvent,
} from './utils/upload-id-verification.handlers.utils';

const manageReceivedDataFromVeridasOCREventHandler = ({
  handleTrackWebSocketError,
  message,
  setCurrentState,
  setError,
  setUploadIdState,
}: UploadIdVerificationReceiveDataBuilderHandlersType): void => {
  switch (true) {
    case customerInformationNeedApproval(message): // No cuadra el OCR
      setUploadIdState(UploadIdStatesEnumeration.DIFFERENT_DATA);
      break;
    case OCRDataIsSuccessfullyVerified(message): // Ha ido bien
      setCurrentState(AppStatesEnumeration.LOADING);
      break;
    default: // Ha dado error
      handleTrackWebSocketError(message);
      setError(AppErrorEnumeration.UPLOAD_ID_VERIFICATION_WS_REJECTED);
  }
};

const manageListenVeridasIframeEventsHandler = ({
  event,
  setError,
  setShowLoader,
}: UploadIdVerificationManageListenVeridasIframeEventsHandlerType): void => {
  if (eventIsNotFromVeridas(event.origin)) {
    return;
  }
  const { type, code, infoEvent } = event.data;

  if (shouldShowErrorFromEvent({ code, type, infoEvent })) {
    setError(`${AppErrorEnumeration.VERIDAS_ERROR_EVENT}_${code}` as AppErrorEnumeration);
  }
  if (isQrProcessFinished(infoEvent?.code)) {
    setShowLoader(true);
  }
};

const updateUploadIdHeaderBackClickHandler = ({
  setOnHeaderBackClick,
  setUploadIdState,
}: UploadIdVerificationUpdateHeaderBackClickHandlerType): void => {
  setOnHeaderBackClick(() => () => {
    setUploadIdState(UploadIdStatesEnumeration.LANDING);
  });
};

const UploadIdVerificationHandlers = ({
  setError,
  setShowLoader,
  ...props
}: UploadIdVerificationBuilderHandlersType): UploadIdVerificationMethodsHandlersType => ({
  handleManageReceivedDataFromVeridasOCREvent: (
    message: WsResponseType<UploadIdOcrStatesEnumeration>
  ) => manageReceivedDataFromVeridasOCREventHandler({ message, setError, ...props }),
  handleManageListenVeridasIframeEvents: (event: MessageEvent) =>
    manageListenVeridasIframeEventsHandler({ event, setError, setShowLoader }),
  handleUpdateUploadIdHeaderBackClick: () => updateUploadIdHeaderBackClickHandler(props),
});

export { UploadIdVerificationHandlers };
